import { defineMessages } from 'react-intl';

export default defineMessages({
    coverages: {
        id: 'policycommon.component.policy-common-coverables.Coverage Highlights',
        defaultMessage: 'Coverage Highlights'
    },
    coverageContent: {
        id: 'tdic.policycommon.component.policy-common-coverables.This policy details page is not a policy document and does not change any provisions of your policy. There are exclusions, limitations, and conditions that apply to each coverage. If there is any conflict between your policy and this information, the provisions of your policy will apply. Please refer to your policy documents for more information.',
        defaultMessage: 'This policy details page is not a policy document and does not change any provisions of your policy. There are exclusions, limitations, and conditions that apply to each coverage. If there is any conflict between your policy and this information, the provisions of your policy will apply. Please refer to your policy documents for more information.'
    },
    wcCoverageTitle: {
        id: 'tdic.policycommon.component.policy-common-coverables.Workers\' Compensation Insurance Part One (Section 3A)',
        defaultMessage: 'Workers\' Compensation Insurance: Part One (Section 3A)'
    },
    wcCoverageField: {
        id: 'tdic.policycommon.component.policy-common-coverables.See policy documents for coverage details',
        defaultMessage: 'See policy documents for coverage details'
    }
});
